import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataTmp, generateBody, generateReference, groupByComponentName, groupByNameHeading, groupByNameTable } from '../../report-common';
import templateOne from '@/entities/insights/template-report/template-one/template-one.vue';
@Component({
  name: 'report-setting',
  components: {
    'template-one': templateOne,
  },
})
export default class reportSetting extends Vue {
  @Prop() readonly detailReport: any | undefined;
}
